// extracted by mini-css-extract-plugin
export default {"content":"src-client-components-Dropdown-styles-___default__content___EFa0I"};